import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style.js';
import classnames from 'classnames';

import Icon from 'js/components/common/Icon';

const CarouselButton = styled.button`
  @media(min-width: ${device.laptop}) {
    display: none;
  }
  & {
    ${({ disabled }) => {
      if(disabled) {
        return `
          color: #E5E9FD;
        `;
      } 
      return `
        color: #667FFE;
      `;
    }}
    border: none;
    background: none;
    font-size: 24px;
    position: absolute;
    top: 50%;
    z-index: 9999;
    right: ${({ right }) => right || 'auto'};
    left: ${({ left }) => left || 'auto'};
  }

  &.disabled {
    color: #E5E9FD;
  }
`;

function DAINavigatorButton({
  className,
  disabled,
  iconName,
  onAction,
  ...rest
}) {
  return (
    <CarouselButton
      className={classnames(className, disabled ?? 'disabled')}
      disabled={disabled}
      onClick={() => onAction()}
      {...rest}
    >
      <Icon name={iconName}></Icon>
    </CarouselButton>
  )
}

export default DAINavigatorButton;